// A menu entry drawn as a page's primary action — *New key* on an app's page,
// *Disconnect* on a member's — asked first exactly as the row menu asks it
// (01-the-console.md § conventions: a row's actions, remove).

import { useState } from "react";

import { Button } from "../../ui/components.tsx";
import { ConfirmDialog, type MenuEntry } from "../../ui/table.tsx";

export function AskedButton({ entry }: { entry: MenuEntry }) {
  const [asking, setAsking] = useState(false);
  return (
    <>
      <Button
        kind="primary"
        onClick={() => {
          if (entry.confirm === undefined) {
            entry.onSelect();
          } else {
            setAsking(true);
          }
        }}
      >
        {entry.label}
      </Button>
      {asking && entry.confirm !== undefined && (
        <ConfirmDialog
          ask={entry.confirm}
          verb={entry.confirm.verb ?? entry.label}
          danger={entry.danger === true}
          onCancel={() => {
            setAsking(false);
          }}
          onConfirm={() => {
            setAsking(false);
            entry.onSelect();
          }}
        />
      )}
    </>
  );
}
